import { Injectable, signal } from '@angular/core';
import { iAlert } from './entities';

@Injectable({ providedIn: 'root' })
export class AlertService {

  private readonly _alert = signal<iAlert>({
     visible: false
  });
  
  readonly alert = this._alert.asReadonly();

  fill(data: Omit<iAlert, 'visible'>) {
    this._alert.set({
      visible: false,
      ...data
    });
  }
  show() {
    this._alert.set({
      visible: true,
      ...this._alert
    });
  }
  hide() {
    this._alert.set({ visible: false });
  }
  
  error(p_msg: string) {
    this._alert.set({ msg: p_msg, title: "Falha ao enviar", type: "error", visible: true });
    console.error('❌ :', p_msg);

    setTimeout(() => {
      this._alert.set({ visible: false });

        this.hide();
    }, 3690);
  }

  success(p_msg: string) {

    // let l_msg = `
    //       Solicitação enviada com <b style="color: #000">sucesso</b><br/><br/>
    //       Entraremos em contato<br/> dentro de 24 hrs<br/>
    //       Seja bem-vindo a <b>NEW FIGHT</b>`;
    
    let l_msg = `
          Inscrição enviada com <b style="color: #fff">sucesso</b><br/><br/>
          `;

    this._alert.set({ msg: l_msg, title: "Sucesso", type: "success", visible: true });

    console.log('✅ :', p_msg);

    setTimeout(() => {
      this._alert.set({ visible: false });

        this.hide();
    }, 3690);
  }

  info(p_msg: string) {
    this._alert.set({ msg: p_msg, title: "Info", type: "info", visible: true });

    console.info('ℹ️ :', p_msg);

    setTimeout(() => {
      this.hide();
    }, 3690);
  }

  warning(p_msg: string) {
    this._alert.set({ msg: p_msg, title: "Aviso", type: "warning", visible: true });

    console.warn('⚠️ :', p_msg);

    setTimeout(() => {
      this.hide();
    }, 3690);
  }

}
